/* eslint-disable */
import api from '../redux/api';
import { Claim } from '../models/claim';
import { SubmitClaimRequest } from '../models/request/submitClaimRequest';
import { PolicyBasicInfo } from '../models/policyBasicInfo';
import { ClaimStatusDefinition } from '../models/claimStatusDefinition';

export const claimsApiSlice = api.injectEndpoints({
  endpoints: (build) => ({
    getClaims: build.query<Claim[], void>({
      query: () => "claimMgmt/BaseCustomerData/claims",
      transformResponse: (response: any[]) => response.map(dto => new Claim(dto))
    }),
    getClaimStatusDefinition: build.query<ClaimStatusDefinition, string>({
      query: (claimDefUId) => `claimMgmt/BaseCustomerData/claim-definitions/${claimDefUId}/statuses`
    }),
    getPoliciesAvailableForClaimCreation: build.query<PolicyBasicInfo[], void>({
      query: () => "claimMgmt/BaseCustomerData/policies",
      transformResponse: (response: any[]) => response.map(dto => new PolicyBasicInfo(dto))
    }),
    submitClaim: build.mutation<any, SubmitClaimRequest>({
      invalidatesTags: ["Claim"],
      query: (body) => ({
        url: "claimMgmt/BaseCustomerData/claims/submit",
        method: "POST",
        body,
      }),
    })
  })
});

export const {
  useGetClaimsQuery,
  useGetClaimStatusDefinitionQuery,
  useGetPoliciesAvailableForClaimCreationQuery,
  useSubmitClaimMutation
} = claimsApiSlice;
